export const subscriptionStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  PAUSED: 'paused',
  CANCELLED: 'cancelled',
  IN_TRIAL: 'inTrial',
  DELETED: 'deleted',
};

export type SubscriptionStatusesTypes =
  typeof subscriptionStatuses[keyof typeof subscriptionStatuses];
